import React from 'react';

const formatTime = (time) => {
  if (!time) return '0m';
  const { day = 0, hours = 0, minute = 0 } = time;
  return `${day}d ${hours}h ${minute}m`;
};

const WorkLogStats = ({ estimate, logs }) => {
  const total = logs.reduce(
    (acc, log) => {
        const logTime = JSON.parse(log.spend_time || '{}');
        //const logTime = JSON.parse(log.EstLog || '{}');
      acc.day += logTime.day || 0;
      acc.hours += logTime.hours || 0;
      acc.minute += logTime.minute || 0;
      return acc;
    },
    { day: 0, hours: 0, minute: 0 }
  );

  while (total.minute >= 60) {
    total.hours += 1;
    total.minute -= 60;
  }
  while (total.hours >= 24) {
    total.day += 1;
    total.hours -= 24;
  }

  return (
    <div className="text-sm text-gray-700">
      <span className="font-medium">Estimated:</span> {formatTime(estimate)} &nbsp;|&nbsp;
      <span className="font-medium">Logged:</span> {formatTime(total)}
    </div>
  );
};

export default WorkLogStats;